import React from 'react';
import styles from './styles.module.css';

import PillButton from '../../../../components/pill-button';
import CrossIcon from '../../../../icons/Cross';

export default ({ backToForm, submit }) => (
  <div className={styles.container}>
    <CrossIcon size={96} color="#AD343E" />
    <p>Failed to send submission</p>
    <p>There may be an issue with our system. Please try again later.</p>
    <div className={styles.buttons}>
      <PillButton theme="grey-ghost" text="Back" onClick={backToForm} />
      <PillButton theme="blue" text="Retry" onClick={submit} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/page-components/contact-us/contact-form/submission-failed-stage/index.js